import { render } from "./SessionsView.vue?vue&type=template&id=e1a845f4&scoped=true"
import script from "./SessionsView.vue?vue&type=script&lang=js"
export * from "./SessionsView.vue?vue&type=script&lang=js"

import "./SessionsView.vue?vue&type=style&index=0&id=e1a845f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1a845f4"]])

export default __exports__